export const ru = {
    'no-rights': 'Недостаточно прав для применения рекомендации',
    'progress-title': 'Применяем рекомендацию'
};
